<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import SourceDriverForm from "./forms/source-driver-form.vue";
import CustomTable from "../../../components/tables/custom-table.vue";
import AddButton from "../../../components/buttons/add-button.vue";

/**
 * Customers Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    AddButton,
    SourceDriverForm,
    CustomTable
  },
  data() {
    return {
      modalId:'source-driver-form-modal',
      pageHeader:{
        title: "Source Drivers",
        breadcrumbs: [
          {
            text: "Source Drivers",
            href: "/source-drivers",
            active: true
          }
        ],
      },
      table:{
        url:'/source-drivers',
        fields:[
          { key: "id", label: "Cod", sortable: true },
          { key: "name", label: "Name", sortable: true },
          { key: "source_driver_type.name", label: "Driver type", sortable: false },
        ]
      },
      selectedItemId:null      
    };
  },
  methods: {
    showEditModal(item) {
      this.selectedItemId = item?.id || null;
      this.$bvModal.show(this.modalId);
    },
    onSuccess(){
      this.$refs.customerTable.refresh();
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="pageHeader?.title" :items="pageHeader?.breadcrumbs" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <SourceDriverForm :modal-id="modalId" :id="selectedItemId" @onSuccess="onSuccess"></SourceDriverForm>
            <div class="text-right">
              <AddButton @click="showEditModal"></AddButton>
            </div>
            <CustomTable :url="table.url" :fields="table.fields" @edit="showEditModal" ref="customerTable"></CustomTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>